module.exports = __webpack_public_path__ + "creditcards.svg?e2f55f4054daca728bf485a9fd64498e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/creditcards.svg
// module id = 25
// module chunks = 0